import { IState, IUpdateAdditionalCcAction } from '../../../../types/state';

export const updateAdditionalCC = (state: IState, action: IUpdateAdditionalCcAction): IState => ({
    ...state,
    additionalCc: [...action.additionalCc.map((member) => member.email)],
  });
